export default __webpack_public_path__ + "static/media/020_start.vp8.836f7b27.webm";